import { ReactNode } from 'react';
import styles from './InfoBlock.module.css';

const InfoBlock = ({ label, children }: { label: ReactNode; children: ReactNode }) => {
  return (
    <div className={styles.infoBlock}>
      <div className={styles.infoValue}>{children}</div>
      <div className={styles.infoLabel}>{label}</div>
    </div>
  );
};

export default InfoBlock;
